import { z } from 'my-zod'

export const customerWaiverImageOtherSignatureUrl = z.object({
  additionalParticipantFullName: z.string().nullable(),
  isParticipantMinor: z.boolean().nullable(),
  signatureUrl: z.string()
})

export type customerWaiverImageOtherSignatureUrl = z.infer<typeof customerWaiverImageOtherSignatureUrl>

export const customerWaiverImageReferencesModel = z.object({
  id: z.string().uuid(),
  waiverId: z.string().uuid(),
  driverLicenseUrl: z.string().nullable(),
  driverFrontLicenseUrl: z.string().nullable(),
  signatureUrl: z.string().nullable(),
  otherSignatureUrls: customerWaiverImageOtherSignatureUrl.array(),
  isEhs: z.boolean().nullable(),
  isGuest: z.boolean().nullable(),
  isClassicSigned: z.boolean().nullable()
})

export type customerWaiverImageReferencesModel = z.infer<typeof customerWaiverImageReferencesModel>
